'use client';


import { loadSounds, playSfx, wireUnlock } from '../lib/audioEngine';

const IMAGE_SRCS = [
  '/chicken-cs2.webp',
  '/feather-1.webp',
  '/feather-2.webp',
  '/feather-3.webp',
  '/chicken-cyber.webp',
  '/feather-cyber-1.webp',
  '/feather-cyber-2.webp',
  '/feather-cyber-3.webp',
];

let preloadStarted = false;

function preloadImages() {
  for (const src of IMAGE_SRCS) {
    const img = new Image();
    img.src = src;
  }
}

export function preloadChickenAssets(): void {
  if (preloadStarted || typeof window === 'undefined') return;
  preloadStarted = true;
  wireUnlock();
  preloadImages();
  void loadSounds(['killchicken']).catch(() => undefined);
}

export function playChickenSound(volume = 1): void {
  playSfx('killchicken', volume);
}
